import { render, staticRenderFns } from "./TedsLauncherUpdateColors.vue?vue&type=template&id=89acf0d0&"
import script from "./TedsLauncherUpdateColors.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherUpdateColors.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherUpdateColors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports